module.exports = __webpack_public_path__ + "static/media/gaming.6c0e39d0.svg";